import type { FC } from "react";
import React, { useState } from "react";

import { bindArgs } from "@core/foundation/function";

import { Button } from "@react/ui-primitives/button";

import type { MemoryApiKey } from "@apis/memory/models";

interface MemoryApiKeyContentProps {
  readonly memoryApiCredential: string;
  readonly memoryApiKey: MemoryApiKey;
}

export const MemoryApiKeyContent: FC<MemoryApiKeyContentProps> = ({
  memoryApiCredential,
  memoryApiKey,
}) => {
  const [copied, setCopied] = useState(false);

  const copy = (value: string): void => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true);
      })
      .catch(() => {
        setCopied(false);
      });
  };

  return (
    <div className="flex min-w-0 flex-col gap-3">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-xs font-semibold">Key</span>
        <code className="rounded-md border p-2 text-xs break-all">
          {memoryApiKey}
        </code>
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-xs font-semibold">Credential</span>
        <div className="flex items-center gap-2">
          <code className="min-w-0 flex-1 rounded-md border p-2 text-xs break-all">
            {memoryApiCredential}
          </code>
          <Button
            className="w-32 shrink-0"
            onClick={bindArgs(copy, memoryApiCredential)}
            size="sm"
            variant="outline"
          >
            {copied ? "Copied" : "Copy credential"}
          </Button>
        </div>
      </div>
    </div>
  );
};
